import React, { useEffect, useRef, useState } from "react";
import styles from "../../../ShareComponent/ShareComponent.module.css";
import { toast } from "react-toastify";
import config from "../../../../config";
import { CircularProgress } from "@mui/material";
import { getApi, postApi } from "../../../../pages/AppApis";
import Email from "../../../../assets/svg/Email.svg";
import Facebook from "../../../../assets/svg/Facebook.svg";
import WhatsApp from "../../../../assets/svg/WhatsApp.svg";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { icon } from "leaflet";
import { IoLinkOutline } from "react-icons/io5";
import { showErrorToast, showSuccessToast } from "../../../../pages/utils";

const shareOptions = [
    {
        // icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/7525cc9680581556050c639fefe098ec290f3de1ad7d21058cd0fed4b7aa5fbc?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
        icon: Email,
        label: "Email",
        type: "email",
    },
    {
        // icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/3e473e4510052f59b40f886744713811ff9e3c8ac1b12b390d46192c1a5a8791?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
        icon: Facebook,
        label: "Facebook",
        type: "facebook",
    },
    {
        // icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/3e473e4510052f59b40f886744713811ff9e3c8ac1b12b390d46192c1a5a8791?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
        icon: WhatsApp,
        label: "WhatsApp",
        type: "whatsapp",
    },
];

const MediaShareModal = ({ shareModalRef, selectedFile, onClose, property }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authUser");
            const response = await getApi(`/messaging/conversations`);
            if (response?.error === 401) {
                // throw new Error(data.error);
                navigate("/login");
            }
            const data = response.response;

            if (Array.isArray(data)) {
                setUsers(data);
            } else {
                console.error("Unexpected response format:", data);
                setUsers([]);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };
    // Construct the fileUrl using the provided logic
    const fileUrl = selectedFile[0]?.fileUrl;

    const handleShare = (type) => {
        if (!fileUrl) {
            console.error("File URL is undefined");
            showErrorToast("File URL is missing.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return;
        }

        // Generate platform-specific share URL using the current domain
        // This ensures that links shared from onMLS use the onMLS domain
        const currentOrigin = window.location.origin;
        const propertyId = property?.ListingId || property?.property_id;
        let href = property ? `${currentOrigin}/preview/${propertyId}` : fileUrl;

        switch (type) {
            case "email":
                window.open(
                    `mailto:?subject=${encodeURIComponent("Document")}&body=${encodeURIComponent("Please check this document: " + href)}`,
                    "_blank"
                );
                break;
            case "whatsapp":
                // WhatsApp sharing implementation
                const whatsappText = `Check out these images: ${selectedFile.map((item) => item.fileUrl).join(", ")}`;
                window.open(`https://wa.me/?text=${encodeURIComponent(whatsappText)}`, "_blank");
                break;
            case "facebook":
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(href)}`, "_blank");
                break;
            case "twitter":
                window.open(`https://twitter.com/share?url=${encodeURIComponent(href)}`, "_blank");
                break;
            case "link":
                navigator.clipboard
                    .writeText(href)
                    .then(() => {
                        showSuccessToast("Link copied to clipboard!", {
                            autoClose: 3000,
                            pauseOnHover: false,
                        });
                    })
                    .catch(() => {
                        showErrorToast("Failed to copy the link.", {
                            autoClose: 3000,
                            pauseOnHover: false,
                        });
                    });
                break;
            default:
                break;
        }
    };

    const handleUserClick = async (user) => {
        if (!fileUrl) {
            console.error("File URL is undefined", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            showErrorToast("File URL is missing.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return;
        }

        const token = localStorage.getItem("authUser");
        const formData = new FormData();
        formData.append("receiver_id", user.user_id);
        formData.append("property_id", user.property_id);
        formData.append("message", fileUrl); // Use the constructed fileUrl
        formData.append("property_price", 12);

        try {
            const response = await postApi("/users/buyer/sellers/chat", formData, true);

            if (response.response) {
                showSuccessToast(`File link sent successfully to ${user.first_name} ${user.last_name}`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } else if (response?.error === 401) {
                // throw new Error(data.error);
                navigate("/login");
            } else {
                showErrorToast(`Failed to send file link to ${user.first_name} ${user.last_name}`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }
        } catch (error) {
            console.error("Error sending file link:", error);
            showErrorToast("An error occurred while sending the file link.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        }
    };

    const getInitials = (firstName, lastName) => {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    };

    useEffect(() => {
        // Load the Facebook SDK
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: process.env.REACT_APP_FACEBOOK_APP_ID, // Replace with your app ID
                autoLogAppEvents: true,
                xfbml: true,
                version: "v12.0", // Use the latest version
            });
        };

        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }, []);

    const shareImages = () => {
        const imageUrls = selectedFile.map((item) => {
            return item.fileUrl;
        });
        // Authenticate the user
        window.FB.login(
            (response) => {
                if (response.authResponse) {
                    // User is authenticated, now we can upload images
                    imageUrls.forEach((url) => {
                        window.FB.api("/me/photos", "POST", { url: url, caption: "Check out this image!" }, function (response) {
                            if (!response || response.error) {
                                console.error("Error occurred:", response.error);
                            } else {
                            }
                        });
                    });
                } else {
                }
            },
            { scope: "publish_actions" }
        ); // Ensure you have the right permissions
    };

    return (
        <div className="tw-fixed tw-inset-0 tw-items-center tw-flex tw-justify-center tw-z-[9999] tw-bg-black tw-bg-opacity-75">
            <section
                ref={shareModalRef}
                className={`tw-relative tw-w-[40%] max-sm:tw-w-full max-sm:tw-fixed max-sm:tw-bottom-0 max-sm:tw-left-0 max-sm:tw-right-0 max-sm:tw-p-5 max-md:tw-w-[60%] max-md:tw-p-5 tw-flex tw-flex-col tw-gap-[20px] ${styles.alert}`}
            >
                <header className={`${styles.header} tw-pb-3 tw-border-b-1`}>
                    <h2 className={`${styles.shareText} tw-text-black tw-font-semibold`}>Share</h2>
                    <button onClick={onClose} className=" tw-bg-background_color tw-p-[10px] tw-rounded-full tw-text-gray-500 hover:tw-text-gray-700">
                        <RxCross1 className="tw-text-[16px]" />
                    </button>
                </header>

                <h3 className={"tw-text-light_text"}>Share this property via</h3>

                <footer className={`  tw-flex tw-justify-between tw-items-center`}>
                    <div className={styles.shareOptions}>
                        <div className={styles.optionsContainer}>
                            {shareOptions.map((option, index) => (
                                <div
                                    key={index}
                                    className={`${styles.optionItem} tw-bg-background_color tw-p-3`}
                                    onClick={() => {
                                        if (option.type === "facebook") {
                                            shareImages();
                                        } else {
                                            handleShare(option.type);
                                        }
                                    }}
                                >
                                    {option.icon && <img src={option.icon} alt="" className={`${styles.optionIcon} `} />}
                                </div>
                            ))}
                        </div>
                    </div>
                    <button
                        className={
                            "tw-flex tw-flex-col tw-gap-1 tw-w-fit tw-p-2 tw-rounded-md  tw-items-center tw-justify-center tw-bg-background_color tw-h-fit"
                        }
                        onClick={() => handleShare("link")}
                    >
                        {/* <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/78228155766b9a3d844b1190412ae389deec0b8461473124f2af9c17407b192f?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt=""
                            className={styles.copyLinkIcon}
                        /> */}
                        <IoLinkOutline className="tw-text-[30px] tw-text-primary" />

                        <span className="tw-text-[14px] tw-text-nowrap">Copy link</span>
                    </button>
                </footer>
            </section>
        </div>
    );
};

export default MediaShareModal;
